// hooks/useEquipmentInvoice.ts
import { useState, useEffect, useCallback } from 'react';
import { equipmentInvoiceService } from 'shared/services';
import toast from 'shared/utils/toast';
import { IEquipmentInvoice } from '../types';

export function useEquipmentInvoice(invoiceId: string | undefined) {
  const [invoice, setInvoice] = useState<IEquipmentInvoice>();
  const [isCreditMemoGenerating, setIsCreditMemoGenerating] = useState(false);
  const [isLinesDialogOpen, setIsLinesDialogOpen] = useState(false);

  const fetchInvoiceDetail = useCallback(() => {
    if (invoiceId) {
      equipmentInvoiceService.get(Number(invoiceId)).then(setInvoice);
    }
  }, [invoiceId]);

  useEffect(() => {
    fetchInvoiceDetail();
  }, [fetchInvoiceDetail]);

  const updateInvoice = useCallback(
    (formValues: any) => {
      if (!invoiceId) return;
      return equipmentInvoiceService
        .update(Number(invoiceId), formValues)
        .then((updatedInvoice) => {
          setInvoice(updatedInvoice);
          toast.crud.successUpdate('Fattura', 'f');
        });
    },
    [invoiceId]
  );

  const downloadCreditMemo = useCallback(() => {
    if (invoiceId) equipmentInvoiceService.downloadCreditMemo(Number(invoiceId));
  }, [invoiceId]);

  const downloadInvoiceAgreement = useCallback(() => {
    if (invoiceId) equipmentInvoiceService.downloadInvoiceAgreement(Number(invoiceId));
  }, [invoiceId]);

  const sendCreditMemoEmail = useCallback(() => {
    if (invoiceId) equipmentInvoiceService.emailCreditMemo(Number(invoiceId));
  }, [invoiceId]);

  const sendInvoiceAgreementEmail = useCallback(() => {
    if (invoiceId) equipmentInvoiceService.emailInvoiceAgreement(Number(invoiceId));
  }, [invoiceId]);

  const generateAndDownloadCreditMemo = useCallback(() => {
    if (!invoiceId) return;
    setIsCreditMemoGenerating(true);
    equipmentInvoiceService
      .generateCreditMemo(Number(invoiceId))
      .then(() => {
        fetchInvoiceDetail();
        downloadCreditMemo();
      })
      .finally(() => setIsCreditMemoGenerating(false));
  }, [invoiceId, fetchInvoiceDetail, downloadCreditMemo]);

  return {
    invoice,
    isCreditMemoGenerating,
    isLinesDialogOpen,
    setIsLinesDialogOpen,
    updateInvoice,
    downloadInvoiceAgreement,
    sendCreditMemoEmail,
    sendInvoiceAgreementEmail,
    generateAndDownloadCreditMemo
  };
}
